export default __webpack_public_path__ + "media/success-tick.2c490102.svg";